var exports = {
  "k": "xa15a2ab7--df1a19--container",
};

module.exports = exports;
